import {Component, OnInit, NgZone} from '@angular/core';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {DialogsService} from '../../services/dialog.service';
declare var google: any;

@Component({
  selector: 'app-coverage-maps',
  templateUrl: './coverage-maps.component.html',
  styleUrls: ['./coverage-maps.component.css']
})
export class CoverageMapsComponent implements OnInit {
  marketAreas: any[] = [];
  selectedMarketAreaId: string;
  addressToSearchFor: string;
  addressMarker: any;
  map: any;
  geoCoding = false;
  autocomplete;

  constructor(private realtorPortalService: RealtorPortalService,
              private dialogService: DialogsService, private zone: NgZone) {}

  ngOnInit() {
    this.realtorPortalService.getMarketStatesAndAreas().then(statesAndAreas => {
      console.log(statesAndAreas);
      statesAndAreas.forEach(state => {
        state.MarketAreas.forEach(area => this.marketAreas.push(area));
      });
    });
  }

  geoLocate() {
    this.initAutocomplete();
    // bias toward az locations
    const geolocation = {lat: 33.6816772, lng: -112.1103491};
    const circle = new google.maps.Circle({
      center: geolocation,
      radius: 1000,
    });
    this.autocomplete.setBounds(circle.getBounds());
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('search_address'), {types: ['geocode']});

    this.autocomplete.addListener('place_changed', () => this.fillInAddress());
  }

  fillInAddress() {

  }

  search() {
    this.geoCoding = true;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
        {'address': this.addressToSearchFor}, (results, status) => {

          this.zone.run(() => this.geoCoding = false);
          if (status === google.maps.GeocoderStatus.OK) {
            const loc = results[0].geometry.location;

            if (this.addressMarker != null) {
              this.addressMarker.setMap(null);
            }

            const marker = new google.maps.Marker({
              position: loc,
            });

            this.addressMarker = marker;
            this.addressMarker.setMap(this.map);

          } else {
            // alert("Not found: " + status);
            this.dialogService.alert(
                'Not Found', 'Sorry, we could not locate that address.');
          }
        });
  }

  setMap() {
    setTimeout(() => {


      const kmlUrl = 'https://reports.oneguard.net/kml/' +
                     this.selectedMarketAreaId + '.kml';
      const map_canvas = document.getElementById('map_canvas');
      const map_options = {
        center: new google.maps.LatLng(
            33.661938, -112.110003),  // OneGuard office coordinates, setting as
                                      // default in case of missing kml
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      const map = new google.maps.Map(map_canvas, map_options);
      const kmlOptions = {
        suppressInfoWindows: true,
        preserveViewport: false,
        map: map
      };

      this.map = map;
      // self.marketAreaMap(map);

      new google.maps.KmlLayer(kmlUrl, kmlOptions);
    });
  }
}
